import { Button, CheckBoxGroup, FormLayout } from 'components/common'
import { CommonFormType } from '../utils'
import { useMemo, useState } from 'react'
import { ORDER_KEYS } from 'utils/constants'
import useModal from 'hooks/useModal'
import ConfirmGenerateOrderTokenModal from '../confirmGenerateOrderTokenModal'
import toast from 'react-hot-toast'
import { generateOrderTokenAggregator } from 'utils/api/aggregatorApi'
import CopyTokenModal from '../copyTokenModal'

type OrderConfiguratinFormProps = {
  isEditPage?: boolean
} & CommonFormType

function OrderConfiguratinForm({
  setValue,
  isEditPage = false,
  aggregator,
}: OrderConfiguratinFormProps) {
  const { closeModal, isOpen, openModal } = useModal()
  const {
    closeModal: closeCopyModal,
    isOpen: isOpenCopy,
    openModal: openCopyModal,
  } = useModal()

  const [token, setToken] = useState()

  // options for Page access Permissions
  const { defaultSelected, permissionOptions } = useMemo(() => {
    const permissionOptions = []
    const filteredarr = []

    for (const key in ORDER_KEYS) {
      const option = ORDER_KEYS[key as keyof typeof ORDER_KEYS]
      permissionOptions.push({
        label: option.label,
        value: option.value,
        disabled: false,
      })

      if (!aggregator) {
        filteredarr.push(ORDER_KEYS[key as keyof typeof ORDER_KEYS].value)
      }
    }

    if (aggregator?.order?.requiredFields) {
      for (const key in aggregator.order.requiredFields) {
        if (aggregator.order.requiredFields[key]) filteredarr.push(key)
      }
    }

    return {
      permissionOptions: permissionOptions,
      defaultSelected: filteredarr,
    }
  }, [aggregator])

  const handleConfirmGenerateToken = async () => {
    try {
      const { data } = await generateOrderTokenAggregator(
        aggregator?.aggregatorId,
      )
      if (data?.token) {
        setToken(data.token)
        toast.success('Token has sent to mail', {
          duration: 3000,
        })
      }

      closeModal()
      openCopyModal()
    } catch {
      toast.error('Failed to generate token', {
        duration: 3000,
      })
      closeModal()
    }
  }

  return (
    <>
      <div className="mb-1  gap-5">
        <h3 className="title">Order Configuration</h3>
      </div>

      <ConfirmGenerateOrderTokenModal
        handleConfirm={handleConfirmGenerateToken}
        closeModal={closeModal}
        isOpen={isOpen}
        aggregatorName={aggregator?.aggregatorName}
      />

      <CopyTokenModal
        token={token!}
        closeModal={closeCopyModal}
        isOpen={isOpenCopy}
        aggregatorName={aggregator?.aggregatorName}
      />

      <FormLayout>
        <div className="items-start gap-5 mid-md:flex mid-md:flex-col">
          <p className="mt-1 text-xs text-gray-500">
            Note: The following fields are mandatory and will always be
            included:
            <strong className="text-gray-600">
              Order No, Store Code, Products, Payment, Order Place Datetime, and
              Order Value Incl. Tax.
            </strong>
          </p>

          {/* Order Token */}
          <CheckBoxGroup
            required
            label="Required Order Fields"
            setValue={setValue}
            name="requiredOrderFields"
            options={permissionOptions}
            displayColumn={2}
            defaultSelected={defaultSelected}
            includeSelectAll
          />
          {isEditPage && (
            <div className="w-full border-t-2">
              <p className="mb-2 mt-3 text-xs  font-medium text-gray-600">
                Create Bearer Token
              </p>
              <Button
                buttonText="Generate Bearer Token"
                type="button"
                onClick={openModal}
              />
            </div>
          )}
        </div>
      </FormLayout>
    </>
  )
}

export default OrderConfiguratinForm
